import React from 'react';
import { Link } from 'react-router-dom';
import { ReactComponent as IconDropdownRight } from '../../../assets/dashboard/dropdown-right-icon.svg';

interface IWidgetLinkProps {
  linkTitle: string;
  linkUrl: string;
  testId: string;
  onClick?: () => void;
}

export const WidgetLink = (
  {
    linkTitle,
    linkUrl,
    testId,
    onClick,
  }: IWidgetLinkProps,
) => (
  <div className='flex items-center'>
    <Link id={`widgetLink_${testId}`} to={linkUrl} className='group font-metricR text-bw08 text-sm leading-6 flex items-center hover:text-action03 rounded-[100px]' data-testid={testId} onClick={onClick}>
      {linkTitle}
      <IconDropdownRight className='ml-[2px] relative top-[1px] group-active:bg-action01 transition duration-300 ease-in-out rounded-full' />
    </Link>
  </div>
);
